import Repository from './Repository';
import {NotificationSettingModel, UserModel} from '@/store/types';

const resource: string = '/self';

export class UsersRepository {
  public static get() {
    return Repository.get<UserModel>(`${resource}`);
  }

  public static getSelfInfo() {
    return Repository.get(`${resource}`);
  }

  public static create(name: string) {
    const payload = { name };
    return Repository.post(`${resource}`, payload);
  }

  public static useSlackNotification(use: boolean) {
    const payload = { useSlack: use };
    return Repository.put(`${resource}/settings/notifications/slack`, payload);
  }

  public static setSlackWebhook(url: string) {
    const payload = { slackWebhook: url };
    return Repository.put(`${resource}/settings/notifications/slack`, payload);
  }

  public static useEmailNotification(use: boolean) {
    const payload = { useMail: use };
    return Repository.put(`${resource}/settings/notifications/mail`, payload);
  }

  public static setEmailAddress(address: string) {
    const payload = { mail: address };
    return Repository.put(`${resource}/settings/notifications/mail`, payload);
  }

  public static setNotificationSetting(notification: NotificationSettingModel) {
    return Repository.put(`${resource}/settings/notifications`, notification);
  }
}
